import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=1b59baf4&scoped=true&lang=html&"
import script from "./InviteModal.vue?vue&type=script&lang=js&"
export * from "./InviteModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteModal.vue?vue&type=style&index=0&id=1b59baf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59baf4",
  null
  
)

export default component.exports